import {
    FETCH_USERS_MESSAGES_START,
    FETCH_USERS_MESSAGES_SUCCESS,
    FETCH_USERS_MESSAGES_FAILURE,
    SEND_MESSAGE,
    STOP_FETCH_MESSAGES,
    FETCH_USERS_CHATS_START,
    FETCH_USERS_CHATS_SUCCESS,
    FETCH_USERS_CHATS_FAILURE,
} from "../store/types";

const INITIAL_STATE = {
    chats: [],
    messages: [],
    loading: false,
    error: {
        flag: false,
        msg: null
    }
}

export const chatreducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {


        case FETCH_USERS_CHATS_START:
            return {
                ...state,
                loading: true
            };
        case FETCH_USERS_CHATS_SUCCESS:
            return {
                ...state,
                chats: action.payload,
                loading: false
            };
        case FETCH_USERS_CHATS_FAILURE:
            return {
                ...state,
                chats: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };













        case FETCH_USERS_MESSAGES_START:
            return {
                ...state,
                loading: true
            };
        case FETCH_USERS_MESSAGES_SUCCESS:
            return {
                ...state,
                messages: action.payload,
                loading: false
            };
        case FETCH_USERS_MESSAGES_FAILURE:
            return {
                ...state,
                messages: null,
                loading: false,
                error: {
                    flag: true,
                    msg: action.payload
                }
            };
        case SEND_MESSAGE:
            return state;
        case STOP_FETCH_MESSAGES:
            return INITIAL_STATE;
        default:
            return state;
    }
};